
/**
 * 
 */
export class SituationProfessionnelleModel {

    situationProfessionnelle: string;
}
